<template>
  <div id="app">
    <app-header />
    <main class="app-main">
      <router-view />
    </main>
    <app-footer />
  </div>
</template>

<script>
import AppHeader from '@/components/layout/AppHeader.vue'
import AppFooter from '@/components/layout/AppFooter.vue'

export default {
  name: 'App',
  components: { AppHeader, AppFooter },
}
</script>

<style lang="scss">
@import '@/assets/styles/global.scss';

.app-main {
  min-height: calc(100vh - 72px);
}
</style>
